import { render, staticRenderFns } from "./SchemaEditor.vue?vue&type=template&id=49316e7c&scoped=true&"
import script from "./SchemaEditor.vue?vue&type=script&lang=ts&"
export * from "./SchemaEditor.vue?vue&type=script&lang=ts&"
import style0 from "./SchemaEditor.vue?vue&type=style&index=0&id=49316e7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49316e7c",
  null
  
)

export default component.exports